<template lang="pug">
  #challenge-settings
    WtTile(ancestor vertical :col="12")
        WtTile(:col="12")
          WtTile(parent :col="7")
            WtTile(child :col="12")
              ChallengeCenterAdminChallengeSettings
          WtTile(parent :col="5")
            WtTile(child :col="12")
              //- --------------
              //- CHALLENGE BUILDER
              //- --------------
              WtLabel(
                isLabelElement
                text="Challenge Builder"
                :tooltip-text="builderTooltip"
              )
              .section
                BField.mg-2
                  WtButton.level-item(is-router-link :to="routeObj()") CREATE A CHALLENGE
              //- --------------
              //- MAP BUILDER
              //- --------------
              template(v-if="$auth.user().program.isWellnessMetricsOn")
                WtLabel(
                  isLabelElement
                  text="Challenge Template Builder"
                  tooltip-text="Create a re-usable challenge template to be used in the Challenge Builder."
                )
                .section
                  BField.mg-2
                    WtButton.level-item(is-router-link :to="{ name: 'MapCenterBuilder' }") CREATE A CHALLENGE TEMPLATE

        WtTile(parent)
          WtTile(child :col="12")
            AdminChallengeTable.active-challenges(
              :challenges-data="activeChallenges"
              status="active"
              :loading="!activeChallengesLoaded"
            )

        WtTile(parent)
          WtTile(child :col="12")
            AdminChallengeTable.pending-challenges(
              :challenges-data="pendingChallenges"
              status="pending"
              :loading="!pendingChallengesLoaded"
              default-sort-field="startDate"
            )

        WtTile(parent)
          WtTile(child :col="12")
            AdminChallengeTable.archived-challenges(
              :challenges-data="archivedChallenges"
              :delete-action="deleteArchivedChallenge"
              status="archived"
              :loading="!archivedChallengesLoaded"
              default-sort-field="endDate"
            )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";
import AdminChallengeTable from "@/components/ChallengeCenterAdmin/AdminChallengeTable";
import ChallengeCenterAdminChallengeSettings from "@/components/ChallengeCenterAdmin/ChallengeCenterAdminChallengeSettings";
import WtLabel from "@@/WtLabel/WtLabel";

const CHALLENGE_CENTER_ROUTE_NAME = "ChallengeCenterBuilder";

export default {
  name: "ChallengeSettings",

  components: {
    WtLabel,
    AdminChallengeTable,
    ChallengeCenterAdminChallengeSettings,
    WtButton,
    WtTitle,
    WtTile
  },

  data() {
    return {
      builderTooltip: `This creates an open, program-wide, featured challenge. To create an invite-only personal challenge,
      access the challenges page in your sidebar.
      `
    };
  },

  computed: {
    ...mapGetters("program", [
      "isCoreTier",
      "activeChallenges",
      "activeChallengesLoaded",
      "pendingChallenges",
      "pendingChallengesLoaded",
      "archivedChallenges",
      "archivedChallengesLoaded"
    ])
  },

  mounted() {
    const programId = this.$auth.user().programId;
    Promise.all([
      this.fetchActiveChallenges({ programId, creatorRoleInfo: 1 }),
      this.fetchPendingChallenges({ programId, creatorRoleInfo: 1 }),
      this.fetchArchivedChallenges({ programId, creatorRoleInfo: 1 })
    ]);
  },

  methods: {
    ...mapActions("program", [
      "fetchActiveChallenges",
      "fetchPendingChallenges",
      "fetchArchivedChallenges",
      "removeArchivedChallengeFromList",
      "resetProgramSettingsCopy"
    ]),
    ...mapActions("challenges", ["deleteChallenge"]),

    routeObj(mode) {
      return {
        name: CHALLENGE_CENTER_ROUTE_NAME,
        params: { mode }
      };
    },

    deleteArchivedChallenge(challengeId) {
      this.removeArchivedChallengeFromList(challengeId);
      return this.deleteChallenge(challengeId);
    }
  },

  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      vm.resetProgramSettingsCopy();
    });
  }
};
</script>

<style lang="sass" scoped>
#challenge-settings
  .active-challenges, .pending-challenges, .archived-challenges
    min-height: 200px
</style>
